import cardBrand from '../../constants/card-brand.constants'
import { createActions, createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions(
	{
		setCardBrand: ['cardBrand'],
		setDebitCardNumber: ['debitCardNumber']
	},
	{
		prefix: 'debit-card-purchase/'
	}
)

const initialState = {
	cardBrand: cardBrand.visa,
	debitCardNumber: '0000000000000000'
}

const setDebitCardNumber = (state = initialState, { debitCardNumber }) => ({
	...state,
	debitCardNumber
})

const setCardBrand = (state = initialState, { cardBrand }) => ({
	...state,
	cardBrand
})

export default createReducer(initialState, {
	[Types.SET_CARD_BRAND]: setCardBrand,
	[Types.SET_DEBIT_CARD_NUMBER]: setDebitCardNumber
})
